module.exports = __webpack_public_path__ + "static/media/vn.ed3249c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/vn.svg
// module id = 286
// module chunks = 0